export const LockIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.33329H13.3333C13.7015 5.33329 14 5.63177 14 5.99996V14C14 14.3682 13.7015 14.6666 13.3333 14.6666H2.66667C2.29848 14.6666 2 14.3682 2 14V5.99996C2 5.63177 2.29848 5.33329 2.66667 5.33329H4V4.66663C4 2.45749 5.79086 0.666626 8 0.666626C10.2091 0.666626 12 2.45749 12 4.66663V5.33329ZM7.33333 10.4882V12H8.66667V10.4882C9.0652 10.2577 9.33333 9.82683 9.33333 9.33329C9.33333 8.59689 8.7364 7.99996 8 7.99996C7.2636 7.99996 6.66667 8.59689 6.66667 9.33329C6.66667 9.82683 6.9348 10.2577 7.33333 10.4882ZM10.6667 5.33329V4.66663C10.6667 3.19387 9.47273 1.99996 8 1.99996C6.52724 1.99996 5.33333 3.19387 5.33333 4.66663V5.33329H10.6667Z"
        fill="white"
      />
    </svg>
  );
};
